import md5 from "js-md5";
import Compressor from "compressorjs";
import Axios from "axios";

const SceneMap = {
  avatar: 1,
  photo: 3,
  im: 4
};

const FileTypeMap = {
  jpeg: 1,
  jpg: 1,
  video: 2,
  zip: 3,
  gif: 5,
  png: 6
};

//获取OSS配置并上传文件
const getOssConfig = async (fileScene, contentType, file, id) => {
	let webUrl = ''
	// 开发环境下
	if(process.env.NODE_ENV == 'development') {
		webUrl = "https://www.d0eb2cf6dfd5.com"
	}
	return await Axios.post(webUrl + "/app/comment/comment_put_url", { 
		contentType,
		id
	}).then(async (resp) => {
		const { downloadUrl, putUrl } = resp.data.data;
		handleUpload(putUrl, file);
		await checkOssFileAvailable(downloadUrl);
		console.log("返回地址", downloadUrl);
		return downloadUrl;
	})
}

const uploadToOSS = async (filename, typename, file, resolve, id) => {
	// 保证图片上传成功再返回url
	const url = await getOssConfig(SceneMap.photo, FileTypeMap[typename] || FileTypeMap.jpeg, file, id);
	resolve(url);
};

/**
 *
 * @param {文件} file
 * @param {类型} type
 * @param {图片压缩质量} quality
 * @returns
 */
const upload = (file, type, id, quality = 0.8) => {
	const dateNow = Date.now();
	const year = String(new Date().getFullYear());
	const month = String(new Date().getMonth() + 1);
	const day = String(new Date().getDate());
	const typename = file.type.split("/")[1]
	let filename =
		"goblinweb/" +
		type +
		"/" +
		year +
		"/" +
		(month < 10 ? "0" + month : month) +
		"-" +
		(day < 10 ? "0" + day : day) +
		"/" +
		md5(dateNow + "web") +
		"." +
		typename

	return new Promise((resolve) => {
			if (typename == "jpeg" || typename == "jpg" || typename == "png") {
				console.log("压缩质量", quality);
				new Compressor(file, {
					convertSize: 3000000,
					quality: quality,
					maxHeight: 4000,
					maxWidth: 4000,
					success(result) {
						uploadToOSS(filename, typename, result, resolve, id);
					},
					error() {
						uploadToOSS(filename, typename, file, resolve, id);
					}
				});
			}else {
				uploadToOSS(filename, typename, result, resolve, id);
			}
		})
};

const handleUpload = (putUrl, file) => {
  const reader = new FileReader();
  reader.onload = async function (event) {
    // 检查 event 和 file
    if (!event || !event.target || !event.target.result) {
      console.error('文件读取失败');
      return;
    }
    const imageBlob = new Blob([event.target.result], {
      type: file.type
    });
	let proxyUrl = putUrl

  	await Axios.put(proxyUrl, imageBlob, {
		headers: {
			"Content-Type": file.type
		},
	});
  };
  reader.readAsArrayBuffer(file);
};

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
//检查图片是否可用
const checkOssFileAvailable = async (url, checkCount = 0) => {
  try {
    if (checkCount >= 30) {
      return false;
    }

	let downloadUrl = url

    const res = await Axios.head(downloadUrl, { responseType: "blob" });
    console.log(res);
    if (res.status == 200) {
      return true;
    }
  } catch (error) {
    await sleep(300);
    return await checkOssFileAvailable(url, ++checkCount);
  }
};

export default upload;
